import { InvitationType } from "@vehicle-contract/common/lib/model/contract/SalesContract";
import PhoneNumber from "../../formatting/PhoneNumber";
import { useContract, useRole } from "../ContractContext";

const invitationTypeName = {
  [InvitationType.Sms]: "sms",
  [InvitationType.Email]: "e-post",
};

export interface InvitationStatus {
  shouldInvite: boolean;
  hasInvited: boolean;
  hasAccepted: boolean;
  invitedPhone: string | null;
  invitedEmail: string | null;
  invitationType: InvitationType | null;
  invitedAddress: string | null;
  invitationTypeString: string | null;
}

export function useInvitationStatus(): InvitationStatus {
  const contract = useContract();
  const role = useRole();

  const shouldInvite = contract.initiator === role;

  const hasInvited = !!contract.invitation;

  const invitationType = contract.invitation ? contract.invitation.type : null;
  const invitedPhone = contract.invitation
    ? contract.invitation.recipientPhone
    : null;
  const invitedEmail = contract.invitation
    ? contract.invitation.recipientEmail
    : null;

  const invitedAddress = contract.invitation
    ? invitationType === InvitationType.Email
      ? invitedEmail
      : invitedPhone
    : null;

  const invitationTypeString = contract.invitation
    ? invitationTypeName[contract.invitation.type]
    : null;

  const hasAccepted =
    (contract.invitation && contract.invitation.accepted) || false;

  return {
    shouldInvite,
    hasInvited,
    invitedPhone,
    invitedEmail,
    invitationType,
    invitedAddress,
    hasAccepted,
    invitationTypeString,
  };
}

export function getRecipientString(invitation: InvitationStatus) {
  if (
    invitation.invitationType === InvitationType.Sms &&
    invitation.invitedPhone
  ) {
    return (
      <span>
        <PhoneNumber number={invitation.invitedPhone} /> på{" "}
        {invitation.invitationTypeString}
      </span>
    );
  }
  if (
    invitation.invitationType === InvitationType.Email &&
    invitation.invitedEmail
  ) {
    return (
      <span>
        {invitation.invitedEmail} på {invitation.invitationTypeString}
      </span>
    );
  }
  return null;
}
